// **********************************************************
// Product Showcase
// **********************************************************

const initProductSlider = () => {
  const productShowcaseThumb = document.querySelectorAll('[data-slider="product-showcase-thumb"]');
  const productShowcaseMain = document.querySelectorAll('[data-slider="product-showcase-main"]');

  // 1.1 - Product Thumb Slider
  const getDirection = () => {
    const direction = windowWidth() <= breakpointSm ? 'horizontal' : 'vertical';
    return direction;
  };

  const productShowcaseThumbOptions = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    direction: getDirection(),
    watchOverflow: true,
    freeMode: {
      enabled: true,
      minimumVelocity: 0.1,
      momentumBounce: true,
    },
    mousewheel: true,
    speed: 600,
    navigation: {
      nextEl: '.swiper-button-prev',
      prevEl: '.swiper-button-next',
    },
    breakpoints: {
      767: {
        slidesPerView: 6,
        spaceBetween: 15,
      },
      1023: {
        slidesPerView: 4.5,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: 26,
      },
    },
    on: {
      resize: (ele) => {
        ele.changeDirection(getDirection());
      },
    },
  };

  productShowcaseThumb.forEach((el) => {
    const parentThumbSlider = el.closest('.product-showcase__thumb-slider');
    const arrowRight = parentThumbSlider.querySelector('.arrow-right');
    const arrowLeft = parentThumbSlider.querySelector('.arrow-left');
    productShowcaseThumbOptions.navigation.nextEl = arrowRight;
    productShowcaseThumbOptions.navigation.prevEl = arrowLeft;
    new Swiper(el, productShowcaseThumbOptions);
  });

  // 1.2 - Product Main Slider
  const productShowcaseMainOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    speed: 600,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: false,
    },
    navigation: {
      nextEl: '.swiper-button-prev',
      prevEl: '.swiper-button-next',
    },
  };

  productShowcaseMain.forEach((el, i) => {
    const parentMainSlider = el.closest('.product-showcase__main-slider');
    const arrowRight = parentMainSlider.querySelector('.arrow-right');
    const arrowLeft = parentMainSlider.querySelector('.arrow-left');
    productShowcaseMainOptions.navigation.nextEl = arrowRight;
    productShowcaseMainOptions.navigation.prevEl = arrowLeft;

    productShowcaseMainOptions.thumbs.swiper = productShowcaseThumb[i].swiper;
    new Swiper(el, productShowcaseMainOptions);
  });
};

initProductSlider();
